class ErrorHandler {
  constructor() {
    this.errorMappings = {
      "Invalid token!":
        "Link expired. Please request a new password reset link.",
      "New password should not be the same as current password":
        "You cannot use your old password.",
      "User doesn't exist":
        "We couldn't find your account. Please check and try again.",
    };
  }

  handleErrors(errors) {
    if (!Array.isArray(errors) || errors.length === 0) {
      return errors || "An unknown error occurred. Please try again.";
    }

    for (let i = 0; i < errors.length; i++) {
      const error = errors[i];
      if (this.errorMappings[error]) {
        return this.errorMappings[error];
      }
    }

    return errors.join(", ");
  }
}

export default new ErrorHandler();
